import 'react-app-polyfill/stable';

import TranslationProvider from '@fingo/lib/components/translation/TranslationProvider';
import SnackbarAlert from '@fingo/lib/contexts/snack-bar';
import PropTypes from 'prop-types';
import React from 'react';
import { render } from 'react-dom';
import ApolloProvider from '@fingo/lib/providers/ApolloProvider';
import GoogleTagManagerProvider from '@fingo/lib/providers/GoogleTagManagerProvider';
import UtmCampaignProvider from '@fingo/lib/providers/UtmCampaignProvider';
import MuiProvider from '@fingo/lib/providers/MuiProvider';
import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import App from './App';
import theme from './theme';

const GlobalProviders = ({ children }) => (
  <MuiProvider theme={theme}>
    <ApolloProvider>
      <GoogleTagManagerProvider>
        {children}
      </GoogleTagManagerProvider>
    </ApolloProvider>
  </MuiProvider>
);

GlobalProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

const ContextProviders = ({ children }) => (
  <TranslationProvider platform={REQUESTING_PLATFORM_TO_CODES.BCH} mode="platform">
    <UtmCampaignProvider>
      <SnackbarAlert />
      {children}
    </UtmCampaignProvider>
  </TranslationProvider>
);

ContextProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

const Root = () => (
  <React.StrictMode>
    <GlobalProviders>
      <ContextProviders>
        <App />
      </ContextProviders>
    </GlobalProviders>
  </React.StrictMode>
);

render(<Root />, document.getElementById('root'));
